<!--
  An avatar in a box of fixed size, so nothing moves while it loads: the
  image (loaded lazily), or the name's initial when there is no URL or the
  image cannot load (blocked, gone). Round for a person, square for an
  organization or account. Decorative by default (`alt` empty: the name is
  written beside it); given `alt` when it stands alone.
-->
<script lang="ts">
  interface Props {
    url: string | null | undefined;
    /** Whose it is: gives the initial. */
    name: string;
    shape?: 'round' | 'square';
    /** Width and height, in pixels. */
    size?: number;
    alt?: string;
  }
  let { url, name, shape = 'round', size = 16, alt = '' }: Props = $props();
  /** The URL that failed to load: another URL is tried afresh. */
  let failed = $state<string | null>(null);
</script>

<span class="avatar-box {shape}" style:width="{size}px" style:height="{size}px" style:font-size="{Math.round(size * 0.6)}px"
  >{#if url && failed !== url}<img src={url} {alt} width={size} height={size} loading="lazy" decoding="async" onerror={() => (failed = url)} />{:else}<span
      class="avatar-initial"
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : 'true'}>{name.slice(0, 1).toUpperCase()}</span
    >{/if}</span
>

<style>
  .avatar-box {
    display: inline-block;
    flex: none;
    overflow: hidden;
    vertical-align: middle;
    background: var(--code);
    box-shadow: inset 0 0 0 1px var(--line);
  }
  .avatar-box.round {
    border-radius: 50%;
  }
  .avatar-box.square {
    border-radius: 4px;
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .avatar-initial {
    display: grid;
    place-items: center;
    width: 100%;
    height: 100%;
    color: var(--muted);
    font-family: ui-monospace, SFMono-Regular, Consolas, monospace;
    font-weight: 600;
    line-height: 1;
  }
</style>
